type EmphasizedCopyProps = {
  text: string
  highlight: string
}

export function EmphasizedCopy({ text, highlight }: EmphasizedCopyProps) {
  const position = text.indexOf(highlight)
  if (position === -1 || !highlight) return <>{text}</>

  return (
    <>
      {text.slice(0, position)}
      <strong>{highlight}</strong>
      {text.slice(position + highlight.length)}
    </>
  )
}
